var React = require('react');

function IconMapSettingsLockInactive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#A7AFBB","d":"M25.186 13.572v-.905c0-2.275-1.308-2.767-5.162-2.767s-5.163.372-5.163 2.767v3.108h10.325v-.013h3.337v.035h2.384v17.41H9.11v-17.41h2.384v-3.442c0-4.758 3.796-5.353 8.514-5.353s8.515.595 8.515 5.353v1.217h-3.337zm-5.021 7.703c-1.268 0-2.295 1.043-2.295 2.33a2.34 2.34 0 0 0 1.045 1.954v.375l-.249 3.271h2.997l-.249-3.271a2.28 2.28 0 0 0 0-.375 2.342 2.342 0 0 0 1.045-1.955c0-1.286-1.027-2.329-2.294-2.329z"}));
}

IconMapSettingsLockInactive.defaultProps = {"width":"40","height":"40"};

module.exports = IconMapSettingsLockInactive;

IconMapSettingsLockInactive.default = IconMapSettingsLockInactive;
